import { Component, OnInit, ViewChild, ElementRef   } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';

@Component({
  selector: 'app-liquidar-reteica',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './liquidar_reteica.component.html'
})

export class LiquidarRETEICAComponent implements OnInit {

  showViewHTMLComponent = false;
  controlEnviar = false;
  urlLiquidadorReteIca: string = "";
  tipoId: string | null = "";
  nroId: string | null = "";

  @ViewChild('miFormulario') miFormulario!: ElementRef;

  constructor(private router: Router,
    private authService: AuthService) {
  }

  ngOnInit() {
    const config = this.authService.getValueConfig();
    this.urlLiquidadorReteIca = config.urlLiquidadorReteIca;
  }

  ngAfterViewChecked() {
    if(this.controlEnviar && this.tipoId !== null && this.nroId !== null){
      this.controlEnviar = false;
      this.miFormulario.nativeElement.submit();
    }
  }
  enviar(){
    const user = this.authService.getValueUser();
    this.tipoId = user.tipoId;
    this.nroId = user.nroId;
    this.showViewHTMLComponent = true;
    this.controlEnviar = true;
  }

}
